export const SECTION_TABLE_VIEWPORT_MARGIN = 24;
export const SECTION_TABLE_VIEWPORT_PADDING = SECTION_TABLE_VIEWPORT_MARGIN * 2;
export const SECTION_TABLE_PANEL_MIN_WIDTH = 720;
export const SECTION_TABLE_PANEL_MAX_WIDTH = 1024;
export const SECTION_TABLE_PANEL_MIN_HEIGHT = 524;
export const SECTION_TABLE_MASTER_HEIGHT_RATIO = 540 / 720;
export const SECTION_TABLE_HORIZONTAL_PADDING = 48;
export const SECTION_TABLE_ROW_GAP = 8;
export const SECTION_TABLE_BODY_TOP_PAD = 40;
export const SECTION_TABLE_BODY_BOTTOM_PAD = 16;
export const SECTION_TABLE_CHROME_FALLBACK = 140;
export const SECTION_TABLE_DEFAULT_COLUMN_WIDTH = 154;
export const SECTION_TABLE_CELL_PADDING_X = 16;
export const SECTION_TABLE_SEARCH_MIN_WIDTH = 154;
export const SECTION_TABLE_SEARCH_MAX_WIDTH = 300;
export const SECTION_TABLE_TITLE_MIN_WIDTH = 120;
export const SECTION_TABLE_HEADER_GAP = 12;
export const SECTION_TABLE_COUNT_SCROLL_THRESHOLD = 8;
export const SECTION_TABLE_COPIED_BADGE_MS = 3000;
export { HOVER_PLATE_OPEN_DELAY as SECTION_TABLE_HOVER_DELAY_MS } from '@/modules/common/consts/ui.ts';
export const SECTION_TABLE_EMPTY_ICON_SIZE = 120;
export const SECTION_TABLE_EMPTY_GAP = 10;
export const SECTION_TABLE_EMPTY_SOURCE_GAP = 10;
export const SECTION_TABLE_EMPTY_TEXT_LINE = 24;
export const SECTION_TABLE_EMPTY_PADDING = 23;
export const SECTION_TABLE_EMPTY_ADD_HEIGHT = 24;
export const SECTION_TABLE_EMPTY_BODY_HEIGHT =
  SECTION_TABLE_EMPTY_PADDING * 2 +
  SECTION_TABLE_EMPTY_ICON_SIZE +
  SECTION_TABLE_EMPTY_GAP +
  SECTION_TABLE_EMPTY_TEXT_LINE;
export const SECTION_TABLE_EMPTY_SOURCE_BODY_HEIGHT =
  SECTION_TABLE_EMPTY_PADDING * 2 +
  SECTION_TABLE_EMPTY_ICON_SIZE +
  SECTION_TABLE_EMPTY_SOURCE_GAP +
  SECTION_TABLE_EMPTY_TEXT_LINE;
export const SECTION_TABLE_EMPTY_SOURCE_WITH_ADD_BODY_HEIGHT =
  SECTION_TABLE_EMPTY_SOURCE_BODY_HEIGHT + SECTION_TABLE_EMPTY_SOURCE_GAP + SECTION_TABLE_EMPTY_ADD_HEIGHT;
export const SECTION_TABLE_PANEL_RESIZE_MS = 150;
export const SECTION_TABLE_CONTENT_REVEAL_MS = 50;
export const SECTION_TABLE_MAX_SELECTION = 100;
export const SECTION_TABLE_SELECT_MIN_FIRST_PAGE = 100;
export const SECTION_TABLE_MODAL_VIEWPORT_PADDING = 80;
export const SECTION_TABLE_HEADER_HEIGHT = 68;
export const SECTION_TABLE_APPLIED_FILTERS_ROW_HEIGHT = 24;
export const SECTION_TABLE_TOOLBAR_HEIGHT = 112;
